/* offer-carousel-v2 — native horizontal scroll-snap offers carousel with dots.
   - Dots reflect scroll position; tapping a dot scrolls to that card.
   - The swipe hint hides after the first scroll.
   - Auto cards ([data-ocv2-auto]) recompute pay/strike/{savings} on variant
     change. The price is read in PAISE from the buy box variants JSON +
     the form's selected variant id — never parsed from DOM text. Initial render
     uses the section root's data-current-variant-price (race-free first paint).
   Survives instant-nav subtree swaps (bb:section-reloaded) + theme editor. */
(function () {
  'use strict';

  function fmtINR(n) { return '₹' + Math.round(n).toLocaleString('en-IN'); }
  function grp(n) { return Math.round(n).toLocaleString('en-IN'); }

  // Current variant price in paise — prefer the live selected variant (no text
  // parsing); fall back to the server-written attribute on first paint.
  function currentVariantPaise(root) {
    var bb = root.closest('.beyours-bb');
    if (bb) {
      var formId = bb.getAttribute('data-form-id');
      var form = formId ? document.getElementById(formId) : null;
      var json = bb.querySelector('[data-bb-variants-json]');
      var idInput = form && form.querySelector('input[name="id"]');
      if (json && idInput && !idInput.disabled && idInput.value) {
        try {
          var variants = JSON.parse(json.textContent);
          for (var i = 0; i < variants.length; i++) {
            if (String(variants[i].id) === String(idInput.value)) return variants[i].price;
          }
        } catch (e) {}
      }
    }
    var attr = parseInt(root.getAttribute('data-current-variant-price'), 10);
    return isNaN(attr) ? NaN : attr;
  }

  function recalcAuto(root) {
    var paise = currentVariantPaise(root);
    if (isNaN(paise) || paise <= 0) return;
    var rupees = paise / 100;
    root.setAttribute('data-current-variant-price', paise);
    var autos = root.querySelectorAll('[data-ocv2-auto]');
    Array.prototype.forEach.call(autos, function (card) {
      var pct = parseFloat(card.getAttribute('data-ocv2-pct')) || 0;
      var pay = rupees * (100 - pct) / 100;
      var save = rupees - pay;
      var payEl = card.querySelector('[data-ocv2-pay]');
      var strikeEl = card.querySelector('[data-ocv2-strike]');
      var footEl = card.querySelector('[data-ocv2-foot]');
      if (payEl) payEl.textContent = fmtINR(pay);
      if (strikeEl) strikeEl.textContent = fmtINR(rupees);
      if (footEl) {
        var tpl = footEl.getAttribute('data-ocv2-foot-tpl') || '';
        footEl.textContent = tpl.replace('{savings}', grp(save));
      }
    });
  }

  function initCarousel(root) {
    if (root.dataset.ocv2Init === '1') {
      recalcAuto(root);
      return;
    }
    root.dataset.ocv2Init = '1';

    var track = root.querySelector('[data-ocv2-track]');
    var dotsWrap = root.querySelector('[data-ocv2-dots]');
    var swipeHint = root.querySelector('[data-ocv2-swipe]');
    if (!track) return;

    function cards() {
      return Array.prototype.filter.call(
        track.querySelectorAll('[data-ocv2-card]'),
        function (c) { return !c.hidden; }
      );
    }

    function updateActiveDot() {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.ocv2-dot');
      if (!dots.length) return;
      var list = cards();
      var idx = 0, best = Infinity;
      list.forEach(function (card, i) {
        var d = Math.abs((card.offsetLeft - track.offsetLeft) - track.scrollLeft);
        if (d < best) { best = d; idx = i; }
      });
      Array.prototype.forEach.call(dots, function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
    }

    function buildDots() {
      var list = cards();
      var multi = list.length > 1;
      if (swipeHint) swipeHint.hidden = !multi;
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      if (!multi) return;
      list.forEach(function (card, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ocv2-dot';
        dot.setAttribute('aria-label', 'Go to offer ' + (i + 1));
        dot.addEventListener('click', function () {
          track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
      });
      updateActiveDot();
    }

    var rafId;
    track.addEventListener('scroll', function () {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(updateActiveDot);
    }, { passive: true });

    if (swipeHint) {
      track.addEventListener('scroll', function () {
        swipeHint.style.display = 'none';
      }, { once: true });
    }

    recalcAuto(root); // race-free fresh recalc from live variant / root attribute
    buildDots();
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ocv2]'), initCarousel);
  }
  function recalcAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ocv2]'), recalcAuto);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  window.addEventListener('load', recalcAll);

  // Variant changes — theme dispatches 'variant:changed' on the form; it bubbles
  // to document (same path product-form-alternate.js's repaint relies on).
  document.addEventListener('variant:changed', recalcAll);
  document.addEventListener('variant:change', recalcAll);
  // Radio fallback — defer so <product-variants> writes the id input first.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) {
      setTimeout(recalcAll, 40);
    }
  });

  // Instant-nav subtree swaps + theme editor section loads.
  document.addEventListener('bb:section-reloaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
